import { createStyles } from '@material-ui/core/styles';

const styles = () => createStyles({
  root: {
    display: 'inline-flex',
  },
});

export default styles;
